/**
 * Translates a connector target outcome into the setup-revision event it means,
 * so no caller has to decide for itself what a failure does to the revision.
 */

import type { SetupRevisionEvent } from '../setupRevision/revisionState';
import type { ConnectorTargetOutcome } from './connectorTargetTransaction';

const EventsByOutcome: Record<ConnectorTargetOutcome['kind'], SetupRevisionEvent> = {
  applied: 'revitTargetVerified',
  // A reconfirm changed nothing, but the target is still the verified one.
  unchanged: 'revitTargetVerified',
  blocked: 'revitOperationFailed',
  failed: 'revitOperationFailed',
  // The old target is gone and the new one never landed: nothing is verified.
  'recovery-required': 'recoveryRequiredAfterUndo',
};

export const connectorTargetRevisionEvent = (
  outcome: ConnectorTargetOutcome
): SetupRevisionEvent => EventsByOutcome[outcome.kind];
